import React from 'react';
import ReactDOM from 'react-dom/client';

import { ensureAdminAuth } from 'configs/adminAuth';

import App from './App';

const rootElement = document.getElementById('root');

const render = () => {
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

ensureAdminAuth().finally(render);
